import { Link } from "react-router-dom";

type Cta = {
  href: string;
  label: string;
};

type CrmEmptyStateProps = {
  title: string;
  description: string;
  primaryCta: Cta;
  secondaryCta?: Cta;
};

export function CrmEmptyState({ title, description, primaryCta, secondaryCta }: CrmEmptyStateProps) {
  return (
    <div className="rounded-lg border border-dashed border-gray-300 bg-white px-6 py-10 text-center dark:border-white/20 dark:bg-white/5">
      <h2 className="text-base font-semibold text-gray-900 dark:text-white">{title}</h2>
      <p className="mx-auto mt-2 max-w-md text-sm text-slate-600 dark:text-slate-400">{description}</p>
      <div className="mt-5 flex flex-wrap items-center justify-center gap-3">
        <Link
          to={primaryCta.href}
          className="inline-flex rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white hover:bg-indigo-500"
        >
          {primaryCta.label}
        </Link>
        {secondaryCta ? (
          <Link
            to={secondaryCta.href}
            className="inline-flex rounded-md border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-800 hover:bg-gray-50 dark:border-white/20 dark:text-gray-100 dark:hover:bg-white/10"
          >
            {secondaryCta.label}
          </Link>
        ) : null}
      </div>
    </div>
  );
}
